import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const GuelphHumber = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Guelph-Humber"
      universityShortName="Guelph-Humber"
      slug="university-of-guelph-humber"
      seoTitle="University of Guelph-Humber Study Rooms | Campus Study Guide"
      seoDescription="Complete guide to study rooms at University of Guelph-Humber. Find North Library, Learning Commons, and 24/7 study spaces. Plus free online alternative."
      seoKeywords="guelph humber study rooms, university of guelph humber library, north library, learning resource commons, humber north campus study"
      canonicalUrl="/study-room/university-of-guelph-humber/"
      heroDescription="A comprehensive guide to study rooms and spaces at University of Guelph-Humber, located on Humber College's North Campus."
      libraryWebsiteUrl="https://www.guelphhumber.ca/library"
      libraryWebsiteName="UofGH Library"
      studySpaces={[
        {
          name: "North Library (Learning Resource Commons)",
          features: "Offers bookable group study rooms with collaborative multimedia equipment, quiet study rooms, individual seating, computer work stations, printers, a children's area and archives.",
          feedback: "Group rooms are popular and must be booked via the library's booking system. Some students complain that the library is noisy because people use group areas to socialize—one student noted the library is 'louder than the hallways.'"
        },
        {
          name: "Learning Commons (LRC Third Floor)",
          features: "Includes bookable group study rooms, quiet rooms, an Adaptive Technology Room with 10 workstations, Mac/PC workstations, printers and an Idea Lab with media-production studios and fabrication tools. Some study spaces are open 24/7 for Humber and Guelph-Humber students.",
          feedback: "24/7 spaces can become noisy late at night."
        },
        {
          name: "Quiet Study Room (GH226)",
          features: "Dedicated quiet study room with 17 PCs for focused individual work.",
          feedback: "Students appreciate having a specialized quiet space."
        },
        {
          name: "Practice Presentation Rooms (GH228 & GH229)",
          features: "Rooms that can be booked for presentations or group work practice.",
          feedback: "Must book through the Technology Resource Centre; rules require rooms to be attended and no food."
        },
        {
          name: "Learning Commons Huddle Spaces (GH212C/D)",
          features: "Small group collaboration spaces for quick meetings and study sessions.",
          feedback: "Good for small group work when larger rooms are unavailable."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            The University of Guelph-Humber benefits from Humber College's infrastructure, giving students access to a modern library, 24/7 learning commons and specialized labs.
          </p>
          <p className="mb-4">
            For group projects, <strong>reserve a room in the North Library or the Learning Commons</strong> and take advantage of the built-in screens and collaborative equipment. For solo work, <strong>GH226 offers a dedicated quiet room</strong> with PCs.
          </p>
          <p>
            Keep in mind that some students treat the library like a lounge; if noise becomes unbearable, bring headphones or shift to the practice presentation rooms. The <strong>Idea Lab</strong> is also a great spot to work on creative assignments. Overall, UofGH offers versatility, but you'll need to plan around demand and noise.
          </p>
        </>
      }
      summaryTips={[
        "Book study rooms early: Group rooms are popular and fill up quickly, especially during exam periods.",
        "Use GH226 for quiet study: This dedicated quiet room offers 17 PCs in a focused environment.",
        "Take advantage of 24/7 access: Some Learning Commons spaces are open around the clock for late-night studying.",
        "Bring headphones: The library can get noisy when people use group areas to socialize.",
        "Try CSW for guaranteed quiet: Virtual study rooms offer distraction-free studying when campus is too loud."
      ]}
    />
  );
};

export default GuelphHumber;
